export enum FREEWHEEL_TARGET {
  DESKTOP = 'desktop',
  MOBILEWEB = 'mobileweb'
}
